import { Injectable } from '@angular/core';
import { AuthService } from '@core/service/auth.service';
import { ApplicationConstants } from '@shared/models/constants';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { ConfigurationsService } from 'app/home/configurations/services/configurations.service';
import { PurgeResultVm } from '@core/service/list-actions.service';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  constructor(
    private toastr: ToastrService,
    private authService: AuthService,
    private configService: ConfigurationsService
  ) {}

  getDateFromDbFormatted(dateInUtc: any) {
    if (dateInUtc) {
      return moment(dateInUtc).local().format('YYYY-MM-DDTHH:mm:ssZ');
    } else {
      return '';
    }
  }
  getDateFromDbFormattedDDMMYYYY(dateInUtc: any) {
    if (dateInUtc) {
      return moment(dateInUtc).local().format('DD/MM/YYYY hh:mm A');
    } else {
      return '';
    }
  }
  getDateFromDbFormattedDate(dateInUtc: any) {
    if (dateInUtc) {
      return moment(dateInUtc).local().format('DD/MM/YYYY');
    } else {
      return '';
    }
  }
  getDateFromDb(dateInUtc: Date) {
    return moment(dateInUtc).local();
  }
  getTimeFromDb(dateInUtc: any) {
    return moment(dateInUtc).local().format('hh:mm A');
  }

  getDbTime(time: any) {
    let utcTime = moment(time, 'HH:mm').format('hh:mm A');
    return utcTime;
  }

  getDateInputFormatted(dateInUtc: any) {
    return moment(dateInUtc).format('YYYY-MM-DDTHH:mm:ssZ');
  }

  setDateForDb(dateInLocal: Date) {
    if (dateInLocal) {
      return moment.utc(dateInLocal).format('YYYY-MM-DDTHH:mm:ssZ');
    } else {
      return '';
    }
  }
  setDateFormatted(dateInLocal: Date) {
    if (dateInLocal) {
      return moment(dateInLocal).format('YYYY-MM-DDTHH:mm:ssZ');
    } else {
      return '';
    }
  }
  setDateDepreciationForDb(dateInLocal: Date) {
    if (dateInLocal) {
      return moment.utc(dateInLocal).format('YYYY-MM-DD HH:mm:ssZ');
    } else {
      return '';
    }
  }

  formatDateWithoutConvert(date: Date) {
    if (date) {
      return moment(date).format('YYYY-MM-DD') + ' 00:00:00+00';
    } else {
      return '';
    }
  }

  showDateWithoutConvert(date: Date) {
    if (date) {
      return moment(date).format('DD-MM-YYYY');
    } else {
      return '';
    }
  }

  showDateStringWithoutConvert(date: any) {
    if (date) {
      return moment(date).format('MMMM Do YYYY');
    } else {
      return '';
    }
  }

  showDateStringYYYYMMDD(date: any) {
    if (date) {
      return moment(date).format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  setDateForDbAvailability(dateInLocal: Date) {
    if (dateInLocal) {
      return moment(dateInLocal).format('YYYY-MM-DD HH:mm:ss+');
    } else {
      return '';
    }
  }

  setDateTime(date: any, time: any) {
    let utcDate = moment(date).utc().format('DD-MM-YYYY');
    // let utcTime = moment(time, 'hh:mm A').format('HH:mm');
    return utcDate + ' ' + time;
    // return utcDate + 'T' + utcTime + 'Z';
  }
  getDateTimeFromUtc(date: any, time: any) {
    let utcDate = moment(date).format('DD-MM-YYYY');
    // let utcTime = moment(time, 'hh:mm A').format('HH:mm');
    return moment(utcDate + ' ' + time)
      .local()
      .format('DD-MM-YYYY hh:mm A');
    // return utcDate + 'T' + utcTime + 'Z';
  }

  getDateFromLocal(date: any) {
    if (date) {
      let utcDate = moment(date).format('DD-MM-YYYY');
      return moment(utcDate).local().format('DD-MM-YYYY');
    }
    return moment();
  }

  cardholderDateFormat(date: any) {
    let cardholderDate = '';
    const dateParts = date.split('/');
    if (dateParts.length === 3) {
        const parsedDate = moment(date, 'DD/MM/YYYY', true);
        if (parsedDate.isValid()) {
          cardholderDate = parsedDate.format('DD/MM/YYYY');
        } else {
          cardholderDate = date ? moment(date).format('DD/MM/YYYY') : '';
        }
    } else {
      cardholderDate = moment(date).isValid()
            ? moment(date).format('DD/MM/YYYY')
            : '';
    }
    return cardholderDate;
  }

  cardholderFormDateFormat(date: any) {
    let cardholderDate = '';
    const dateParts = date.split('/');
    if (dateParts.length === 3) {
        const parsedDate = moment(date, 'DD/MM/YYYY', true);
        if (parsedDate.isValid()) {
          cardholderDate = parsedDate.format('YYYY-MM-DDTHH:mm:ssZ');
        } else {
          cardholderDate = 'Invalid Date';
        }
    } else {
      cardholderDate = moment(date).isValid()
            ? moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
            : 'Invalid Date';
    }
    return cardholderDate;
  }

  showErrorToast(msg: string) {
    if (msg != 'OK') {
      this.toastr.error(msg);
    }
  }

  showSuccessToast(msg: string) {
    this.toastr.success(msg);
  }

  showWarningToast(msg: string) {
    this.toastr.warning(msg);
  }

  showInfoToast(msg: string) {
    this.toastr.info(msg);
  }

  showCreateSuccessToast() {
    this.toastr.success('Created Successfully', 'Success');
  }

  showDeleteSuccessToast() {
    this.toastr.success('Deleted Successfully', 'Success');
  }

  showUpdateSuccessToast() {
    this.toastr.success('Updated Successfully', 'Success');
  }

  toDecimal(num: Number) {
    return num.toFixed(2);
  }

  showEmailSuccessToast() {
    this.toastr.success('Email Sent Successfully', 'Success');
  }

  isAdmin(role?: string) {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.ADMIN_ROLE
      ) ?? false
    );
  }

  isReseller(role: string) {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.RESELLER_ROLE
      ) ?? false
    );
  }

  isPrinter(role: string) {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.PRINTER_ROLE
      ) ?? false
    );
  }

  isOrgUser() {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.ORGANIZATION_USER_ROLE
      ) ?? false
    );
  }

  checkUserRole(role: string) {
    return this.authService.currentUserValue?.role?.includes(role) ?? false;
  }

  /**
   * Whether the current user is allowed to Purge a list (destructive bulk-delete).
   * Use this both to show/hide the Purge button AND to re-check right before firing
   * the purge API call - the button visibility alone is not an auth check.
   */
  canPurge(): boolean {
    return this.authService.isAdmin() || this.authService.isPrinter();
  }

  /**
   * Confirms a destructive Purge action in two steps: (1) the usual "are you sure" warning,
   * then (2) a step-up re-authentication where the current user must re-enter their own
   * username/password, verified against Keycloak, before the purge is allowed to proceed.
   * Every list's `purgeList()` calls this one method, so the re-auth step applies everywhere
   * automatically - no per-list changes needed.
   * @param entityLabel human-readable label for the list being purged (e.g. "Orders")
   * @returns true only if the user confirmed AND their credentials were verified
   */
  async confirmPurge(entityLabel: string): Promise<boolean> {
    const confirmation = await Swal.fire({
      title: `Purge ${entityLabel}`,
      text: 'This will permanently remove all records matching the current filters. This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e0272a',
      cancelButtonColor: '#034EA2',
      confirmButtonText: 'Purge',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    });
    if (!confirmation.isConfirmed) {
      return false;
    }
    return this.verifyCurrentUserForPurge();
  }

  /**
   * Prompts the current user to re-enter their username/password and verifies them against
   * Keycloak before a purge is allowed to go ahead - a step-up confirmation for a destructive,
   * irreversible action, distinct from the initial "are you sure" warning.
   */
  private async verifyCurrentUserForPurge(): Promise<boolean> {
    const username = this.authService.currentUserValue?.username ?? '';
    const result = await Swal.fire({
      title: 'Confirm Your Identity',
      html: `
        <div style="text-align: left; box-sizing: border-box;">
          <label for="purge-reauth-username" style="display: block; margin-bottom: 0.5em; font-weight: bold;">Username</label>
          <input id="purge-reauth-username" type="text" readonly style="width: 100%; padding: 0.5em; margin-bottom: 1em; border: 1px solid #dcdcdc; border-radius: 0.25em; background: #f5f5f5;" />
          <label for="purge-reauth-password" style="display: block; margin-bottom: 0.5em; font-weight: bold;">Password</label>
          <input id="purge-reauth-password" type="password" placeholder="Enter your password" autocomplete="current-password" style="width: 100%; padding: 0.5em; border: 1px solid #dcdcdc; border-radius: 0.25em;" />
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e0272a',
      cancelButtonColor: '#034EA2',
      confirmButtonText: 'Verify & Purge',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      focusConfirm: false,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      // Set the username via the DOM API (not string interpolation into the `html` template
      // above) - `preferred_username` comes from the Keycloak JWT and, if it ever contained
      // characters like `"` or `<`, interpolating it into an HTML string would be an XSS risk
      // since SweetAlert2 renders `html` via innerHTML. `.value =` never parses its input as markup.
      didOpen: () => {
        const usernameInput = document.getElementById('purge-reauth-username') as HTMLInputElement;
        if (usernameInput) {
          usernameInput.value = username;
        }
      },
      preConfirm: async () => {
        const password = (document.getElementById('purge-reauth-password') as HTMLInputElement)?.value ?? '';
        if (!password) {
          Swal.showValidationMessage('Please enter your password.');
          return false;
        }
        const isValid = await firstValueFrom(this.authService.verifyCredentials(username, password));
        if (!isValid) {
          Swal.showValidationMessage('Incorrect username or password.');
          return false;
        }
        return true;
      },
    });
    return result.isConfirmed;
  }

  /**
   * Shows the outcome of a Purge call using the API's own response, since a purge can return
   * HTTP 200 while `isSuccess` is false (e.g. some records were skipped due to a business rule
   * like "Some Organizations have Ongoing orders") - that case must surface as a warning with
   * the server's own explanation, not a blanket "Purged Successfully".
   */
  showPurgeResultToast(result?: PurgeResultVm) {
    const message = result?.message?.trim();
    if (result?.isSuccess) {
      this.toastr.success(message || 'Purged Successfully', 'Success');
    } else {
      this.toastr.info(message || 'Purge completed with issues.', 'Purge Incomplete', {
        timeOut: 10000,
        extendedTimeOut: 5000,
      });
    }
  }

  showExportSuccessToast() {
    this.toastr.success('Exported Successfully', 'Success');
  }

getConfigData(configName: string, defaultValue: any = ""): any {
  try {
    const configRaw = localStorage.getItem('configData');
    if (!configRaw || !configName) return defaultValue;

    const configData = JSON.parse(configRaw);
    if (!Array.isArray(configData)) return defaultValue;

    const found = configData.find((x: any) => x?.name === configName);
    return found?.value ?? defaultValue;
  } catch (error) {
    console.warn('Failed to read configData from localStorage:', error);
    return defaultValue;
  }
}
 
  getConfigurationData() {
    this.configService.getConfigurationList().subscribe((res) => {
      localStorage.setItem('configData', JSON.stringify(res));
    });
  }
}
